import React from 'react';
import { SaleWithDetails } from '@/domain/entities';

interface SalesTableProps {
  sales: SaleWithDetails[];
  onViewDetails: (sale: SaleWithDetails) => void;
}

export const SalesTable: React.FC<SalesTableProps> = ({
  sales,
  onViewDetails,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
    }).format(amount);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (!sales || sales.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 shadow ring-1 ring-black ring-opacity-5 dark:ring-gray-700 rounded-lg p-8 text-center text-gray-500 dark:text-gray-400">
        Продажи не найдены
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 shadow-sm overflow-hidden border border-gray-200 dark:border-gray-700 rounded-lg">
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse">
          <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
            <tr>
              <th className="py-2.5 px-4 text-left text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-r border-gray-300 dark:border-gray-600">
                Дата продажи
              </th>
              <th className="py-2.5 px-3 text-left text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-r border-gray-300 dark:border-gray-600">
                Номер заказа
              </th>
              <th className="py-2.5 px-3 text-left text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-r border-gray-300 dark:border-gray-600">
                Клиент
              </th>
              <th className="py-2.5 px-3 text-left text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-r border-gray-300 dark:border-gray-600">
                Источник
              </th>
              <th className="py-2.5 px-3 text-left text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-r border-gray-300 dark:border-gray-600">
                Сумма
              </th>
              <th className="py-2.5 px-3 text-left text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-r border-gray-300 dark:border-gray-600">
                Товаров
              </th>
              <th className="py-2.5 px-3 text-right text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider border-b border-gray-300 dark:border-gray-600">
                Действия
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800">
            {sales.map((sale) => (
              <tr key={sale.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
                <td className="whitespace-nowrap py-2.5 px-4 text-sm font-medium text-gray-900 dark:text-white border-r border-gray-200 dark:border-gray-700">
                  {formatDate(sale.saleDate)}
                </td>
                <td className="whitespace-nowrap py-2.5 px-3 text-sm text-gray-500 dark:text-gray-300 border-r border-gray-200 dark:border-gray-700">
                  {sale.orderNumber}
                </td>
                <td className="py-2.5 px-3 text-sm text-gray-500 dark:text-gray-300 border-r border-gray-200 dark:border-gray-700">
                  <div>{sale.customerName}</div>
                  <div className="text-xs text-gray-400 dark:text-gray-500">{sale.customerContact}</div>
                </td>
                <td className="whitespace-nowrap py-2.5 px-3 text-sm text-gray-500 dark:text-gray-300 border-r border-gray-200 dark:border-gray-700">
                  {sale.sourceName}
                </td>
                <td className="whitespace-nowrap py-2.5 px-3 text-sm font-semibold text-gray-900 dark:text-white border-r border-gray-200 dark:border-gray-700">
                  {formatCurrency(sale.totalAmount)}
                </td>
                <td className="whitespace-nowrap py-2.5 px-3 text-sm text-gray-500 dark:text-gray-300 border-r border-gray-200 dark:border-gray-700">
                  {sale.items?.length || 0}
                </td>
                <td className="whitespace-nowrap py-2.5 px-3 text-right text-sm font-medium">
                  <div className="flex items-center justify-end gap-2">
                    <button
                      onClick={() => onViewDetails(sale)}
                      className="px-3 py-1.5 text-sm font-medium text-indigo-700 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-900/30 border border-indigo-200 dark:border-indigo-700 rounded-lg hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors"
                    >
                      Подробнее
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

